import { render, staticRenderFns } from "./DocumentManagerTable.vue?vue&type=template&id=891cf0d4&scoped=true&lang=pug&"
import script from "./DocumentManagerTable.vue?vue&type=script&lang=js&"
export * from "./DocumentManagerTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManagerTable.vue?vue&type=style&index=0&id=891cf0d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891cf0d4",
  null
  
)

export default component.exports